import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApplicationsResultsService } from '../_services/applications-results-service/applications-results.service';
import { TopologyOverview } from '../_models/topology-overview';
import { TopologyConfig, TopologyList, TopologyWithRoot } from '../_models/topology-list';
import { CommunicationService } from '../_services/communication-service/communication.service';
import { Router } from '@angular/router';
import { P } from '@angular/cdk/keycodes';
import { TranslateService } from '@ngx-translate/core';
import { DateUtils } from '../_commons/date-utils';

@Component({
  selector: 'app-applications-summary-tables',
  templateUrl: './applications-summary-tables.component.html',
  styleUrls: ['./applications-summary-tables.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ApplicationsSummaryTablesComponent implements OnInit {

  DateUtils = DateUtils;
  public isSidebarOpen: boolean;
  public overallResults: Array<TopologyOverview> = new Array<TopologyOverview>();

  overallResultsColumn: any[] = [];
  isSearching: boolean[] = Array(11).fill(false);
  searchText: string[] = Array(11).fill('');

  public topologies: TopologyList;

  @ViewChild('searchInput', { static: false}) searchInputRef! : ElementRef;
  private shouldFocusInput = false;

  public jumpButtonPressed: boolean = false;

  constructor(
    private applicationsResultsService: ApplicationsResultsService,
    private eRef: ElementRef,
    private communicationService: CommunicationService,
    private router: Router,

    public translate: TranslateService,
  ) {

    const lang = localStorage.getItem('Language')
    this.translate.use(lang);
  }

  ngOnInit() {
    this.applicationsResultsService.setSidebarOpen(true);
    console.log('Sidebar Open:', this.applicationsResultsService.getSidebarOpen());
    this.isSidebarOpen = this.applicationsResultsService.getSidebarOpen();

    if(!localStorage.getItem('overallResults')){
      this.getOverallResults();
    }else{
      this.parseCachedOverallResults(JSON.parse(localStorage.getItem('overallResults')));
    }


    this.topologies = JSON.parse(localStorage.getItem('topologies'));
    console.log('Topologies:', this.topologies);
  }

  parseCachedOverallResults(overallResults: any){

    overallResults.forEach((item: any) => {
      // console.log('Cached Overall Results:', item);
      item.forEach((value: any) => {
        // console.log('Cached Overall Results:', value);
        this.overallResults.push({
          topologyId: value.topologyId || "N/A",
          maxNodeLoad: value.maxNodeLoad || "N/A",
          maxVoltage: value.maxVoltage || "N/A",
          minVoltage: value.minVoltage || "N/A",
          totalLaCableViolationCount: value.totalLaCableViolationCount || "N/A",
          totalLaNodeViolationCount: value.totalLaNodeViolationCount || "N/A",
          totalLowerBoundVoltageViolationCount: value.totalLowerBoundVoltageViolationCount || "N/A",
          totalUpperBoundVoltageViolationCount: value.totalUpperBoundVoltageViolationCount || "N/A",
          maxCableLoad: value.maxCableLoad || "N/A",
          intervalStartTimestamp: value.intervalStartTimestamp || "N/A",
          intervalEndTimestamp: value.intervalEndTimestamp || "N/A"
        })
      })
    })
    // console.log('Parsed Overall Results:', this.overallResults);
  }

  resetDefaultTopology(){
    this.communicationService.setTopologyId(null);
  }

  getOverallResults(){
    // let topologyOverviewResult: TopologyOverview;
    this.applicationsResultsService.getOverallResults().subscribe((data: object) => {
      console.log('Overall Results:', data);

      this.overallResults = Object.entries(data).map(([key, value]) => ({
        topologyId: (this.topologies.topologiesWithRoots.find((topology: TopologyWithRoot) => topology.TopologyId === key).displayName
          || (this.topologies.topologiesWithRoots.find((topology: TopologyWithRoot) => topology.TopologyId === key).internalDsoId)
          + " - " + (this.topologies.topologiesWithRoots.find((topology: TopologyWithRoot) => topology.TopologyId === key).TopologyId)) || "N/A",
        maxNodeLoad: value.maxNodeLoad || "N/A",
        maxVoltage: value.maxVoltage || "N/A",
        minVoltage: value.minVoltage || "N/A",
        totalLaCableViolationCount: value.totalLaCableViolationCount || "N/A",
        totalLaNodeViolationCount: value.totalLaNodeViolationCount || "N/A",
        totalLowerBoundVoltageViolationCount: value.totalLowerBoundVoltageViolationCount || "N/A",
        totalUpperBoundVoltageViolationCount: value.totalUpperBoundVoltageViolationCount || "N/A",
        maxCableLoad: value.maxCableLoad || "N/A",
        intervalStartTimestamp: value.intervalStartTimestamp || "N/A",
        intervalEndTimestamp: value.intervalEndTimestamp || "N/A"
      }));
      console.log('Parsed Overall Results:', this.overallResults);
      // save to local storage
      localStorage.setItem('overallResults', JSON.stringify([this.overallResults]));
    })

  }

  sortTable(columnIndex: number): void {
    const table = document.getElementById("sortableTable");
    if (!table) return;

    const rows = Array.from((table as HTMLTableElement).rows).slice(1); // Exclude header row
    let isAscending = table.getAttribute("data-sort-order") === "asc";

    const isNumeric = rows.some(row => {
      const value = row.cells[columnIndex].innerText.trim();
      return !isNaN(parseFloat(value)) && value !== '' && value !== 'N/A' && value !== 'n/a';
    });

    const isDate = rows.some(row => {
      const value = row.cells[columnIndex].innerText.trim();
      return !isNaN(Date.parse(value)) && value !== '' && value !== 'N/A' && value !== 'n/a';
    })

    rows.sort((rowA, rowB) => {
      const cellA = rowA.cells[columnIndex].innerText.trim();
      const cellB = rowB.cells[columnIndex].innerText.trim();

      if (isNumeric) {
        const numbA = (cellA === 'N/A' || cellA === '' || isNaN(parseFloat(cellA))) ? -Infinity : parseFloat(cellA);
        const numbB = (cellB === 'N/A' || cellB === '' || isNaN(parseFloat(cellB))) ? -Infinity : parseFloat(cellB);

        return isAscending ? numbA - numbB : numbB - numbA;
      }

      if(isDate){
        const parseDate = (dateString: string) => {
          const date = new Date(dateString);
          return !isNaN(date.getTime()) ? date : Infinity
        };

        const dateA = parseDate(cellA);
        const dateB = parseDate(cellB);
        return isAscending
          ? (dateA instanceof Date ? dateA.getTime() : 0) - (dateB instanceof Date ? dateB.getTime() : 0)
          : (dateB instanceof Date ? dateB.getTime() : 0) - (dateA instanceof Date ? dateA.getTime() : 0);
      }
      return isAscending ? cellA.localeCompare(cellB) : cellB.localeCompare(cellA);
    });

    table.setAttribute("data-sort-order", isAscending ? "desc" : "asc");
    rows.forEach(row => table.appendChild(row));
  }


  toggleSearch(index: number): void {
    // Мне нужнно сделать так, чтобы при нажатии на кнопку поиска, она меняла свое состояния
    // при этому все остальные кнопки поиска меняли свое состояние на false
    // И каждый раз при нажатии все searchText[index] менялись на пустую строку
    // this.isSearching.forEach((_, i))
    // this.isSearching[index] = !this.isSearching[index];
    setTimeout(() => {
      if(this.jumpButtonPressed){
        this.jumpButtonPressed = false;
        return;
      }

      this.isSearching = this.isSearching.map((_, i) => i === index ? !this.isSearching[i] : false);

      if(this.isSearching.every(value => value === false)){
        this.searchText = Array(11).fill('');
      }
      console.log("Search Toggled:", this.isSearching);

      if(this.isSearching[index]){
        this.shouldFocusInput = true;
      }

    }, 0);

  }

  ngAfterViewChecked(){
    if(this.shouldFocusInput && this.searchInputRef){
      this.searchInputRef.nativeElement.focus();
      // this.shouldFocusInput = false;
      console.log('Focused on search input' + this.shouldFocusInput);
    }
  }

  jumpTopologyMouseDown(){
    this.jumpButtonPressed = true;
  }

  filteredResults(): any[] {

    if(this.isSearching.every(value => value === false)){
      this.searchText = Array(11).fill('');
    }
    if(this.searchText.every(text => !text)){
      return this.overallResults;
    }
    return this.overallResults.filter(item => {
      return this.searchText.every((text, index) => {
        if(!text) return true;
        const value = Object.values(item)[index];
        return value.toString().toLowerCase().includes(text.toLowerCase())
      })
    })
  }

  openInput(){
    console.log('openInput');
  }

  getDispalyNamesOfTopologies() {
    const listOfTopologies: TopologyList =  JSON.parse(localStorage.getItem('topologies'));
  }

  jumpToTheTopology(topologyId: string){
    this.topologies.topologiesWithRoots.forEach((topology: TopologyWithRoot) => {
      if(topology.displayName === topologyId || topology.internalDsoId + " - " + topology.TopologyId === topologyId){
        console.log('Jump to Topology:', topology.TopologyId);
        let topologyConfig: TopologyConfig = new TopologyConfig(
          topology.TopologyId,
          topology.latitude,
          topology.longitude,
          topology.lastTopologyChange
        );

        this.router.navigate(['home']);
        this.communicationService.setTopologyId(topologyConfig);
      }
    })

    // console.log('Jump to Topology:', topologyId);
  }

  getViolationColoring(topologyOverview: any){
    if( topologyOverview.totalLaCableViolationCount > 0 || topologyOverview.totalLaNodeViolationCount > 0 || topologyOverview.totalLowerBoundVoltageViolationCount > 0 || topologyOverview.totalUpperBoundVoltageViolationCount > 0){
      return 'red';
    }
  }
}
